<template>
    <kt-row style="margin-bottom: 50px;padding-right:15px;padding-left: 15px ">
        <div v-for="(signature_holder,index) in signature_holders" v-bind:key="index">
            <hr :id="'signature_holder_hr_tag'+index">
            <kt-row>
                <kt-col xs="6" sm="5" md="4" lg="3">
                    <p style="font-size: medium;display: inline-block">
                        {{ $t('application.signature_holder_detail') }}{{' '}}{{ $i18n.t('ordinal_numbers.' +[index+1] ) }}
                    </p>
                </kt-col>
                <kt-col xs="1" sm="2" md="4" lg="6">
                </kt-col>
                <kt-col xs="5" sm="5" md="4" lg="3">
                    <kt-form-group>
                        <a @click="deleteSignatureHolder(index)"
                           class="w-100 h-100 p-2 pt-3 btn-sm btn btn-label-danger btn-bold float-right">
                            <i class="la la-trash-o"></i>
                            {{ $t('btn.delete') }}
                        </a>
                    </kt-form-group>

                </kt-col>
            </kt-row>

            <kt-row style="margin-top: 20px">
                <kt-col xs="12" sm="6" md="4" lg="3">
                    <kt-form-group>
                        <kt-form-label for="signature_holder_first_name_fa">
                            {{ $t("label.first_name") }}
                        </kt-form-label>
                        <kt-form-control
                                :name="'signature_holders.'+index +'.first_name_fa'"
                                :id="'signature_holder_first_name_fa'+index"
                                v-model="signature_holder.first_name_fa"
                        ></kt-form-control>
                        <p :id="'signature_holder_first_name_fa_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="4" lg="3">
                    <kt-form-group>
                        <kt-form-label for="signature_holder_first_name_en">
                            {{ $t("label.first_name_en") }}
                        </kt-form-label>
                        <kt-form-control
                                dir="ltr"
                                :name="'signature_holders.'+index +'.first_name_en'"
                                :id="'signature_holder_first_name_en'+index"
                                v-model="signature_holder.first_name_en"
                        ></kt-form-control>
                        <p :id="'signature_holder_first_name_en_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="4" lg="3">
                    <kt-form-group>
                        <kt-form-label for="signature_holder_last_name_fa">
                            {{ $t("label.last_name") }}
                        </kt-form-label>
                        <kt-form-control
                                :name="'signature_holders.'+index +'.last_name_fa'"
                                :id="'signature_holder_last_name_fa'+index"
                                v-model="signature_holder.last_name_fa"
                        ></kt-form-control>
                        <p :id="'signature_holder_last_name_fa_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="4" lg="3">
                    <kt-form-group>
                        <kt-form-label for="signature_holder_last_name_en">
                            {{ $t("label.last_name_en") }}
                        </kt-form-label>
                        <kt-form-control
                                dir="ltr"
                                :name="'signature_holders.'+index +'.last_name_en'"
                                :id="'signature_holder_last_name_en'+index"
                                v-model="signature_holder.last_name_en"
                        ></kt-form-control>
                        <p :id="'signature_holder_last_name_en_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="4" lg="3">
                    <kt-form-group>
                        <kt-form-label for="signature_holder_father_name_fa">
                            {{ $t("label.father_name") }}
                        </kt-form-label>
                        <kt-form-control
                                :name="'signature_holders.'+index +'.father_name_fa'"
                                :id="'signature_holder_father_name_fa'+index"
                                v-model="signature_holder.father_name_fa"
                        ></kt-form-control>
                        <p :id="'signature_holder_father_name_fa_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="4" lg="3">
                    <kt-form-group>
                        <kt-form-label for="signature_holder_father_name_en">
                            {{ $t("label.father_name_en") }}
                        </kt-form-label>
                        <kt-form-control
                                dir="ltr"
                                :name="'signature_holders.'+index +'.father_name_en'"
                                :id="'signature_holder_father_name_en'+index"
                                v-model="signature_holder.father_name_en"
                        ></kt-form-control>
                        <p :id="'signature_holder_father_name_en_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="4" lg="3">
                    <kt-form-group>
                        <kt-form-label for="signature_holder_birth_date">
                            {{ $t("label.birth_date") }}
                        </kt-form-label>
                        <datePicker
                                format="YYYY-MM-DD HH:mm:ss"
                                display-format="dddd jDD jMMMM jYYYY"
                                input-class="form-control"
                                :id="'signature_holder_birth_date'+index"
                                :name="'signature_holders.'+index +'.birth_date'"
                                v-model="signature_holder.birth_date"
                                type="date"
                        />
                        <p :id="'signature_holder_birth_date_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>

                </kt-col>
                <kt-col xs="12" sm="6" md="4" lg="3">
                    <kt-form-group>
                        <kt-form-label for="signature_holder_national_code">
                            {{ $t("label.national_code") }}
                        </kt-form-label>
                        <kt-form-control
                                dir="ltr"
                                maxlength="10"
                                :name="'signature_holders.'+index +'.national_code'"
                                :id="'signature_holder_national_code'+index"
                                v-model="signature_holder.national_code"
                        ></kt-form-control>
                        <p :id="'signature_holder_national_code_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
            </kt-row>
        </div>
        <div class="col-12">
            <kt-col xs="7" sm="5" md="4" lg="3" style="position: absolute;left:0;top: 20px">
                <div @click="addSignatureHolder"
                     class="kt-nav__link m-2 btn btn-outline-primary float-right">
                    + {{ $t('application.add_new_signature_holder') }}
                </div>

            </kt-col>
        </div>
        <hr>
    </kt-row>
</template>

<script>
import $ from "jquery";
import {i18n} from '@/plugins/i18n'
import toastr from "toastr";

export default {
    props: {
        signature_holders: {
            required: true,
        },
    },
    computed:{
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    },
    mounted() {
      this.afterDispatch()
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: false,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
        addSignatureHolder() {
            if (this.signature_holders.length === 10)
                return this.toastr.error(i18n.t('application.message.maximum_signature_holder'))

            this.signature_holders.push({
                national_code: '',
                first_name_fa: '',
                first_name_en: '',
                last_name_fa: '',
                last_name_en: '',
                father_name_fa: '',
                father_name_en: '',
                birth_date: '',
            });
        },
        deleteSignatureHolder(index) {
            this.signature_holders.splice(index, 1)
        },
    },
    data() {
        return {}
    }
}
</script>

<style>

</style>